var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle-image-button',{attrs:{"image":_vm.image,"active":_vm.active,"title":_vm.title,"size":_vm.size,"btnClass":'primary ' + _vm.colorClass},on:{"click":function($event){return _vm.$emit('toggleGrayscaleMode')}}})}
var staticRenderFns = []

export { render, staticRenderFns }